<template>
  <button :class="`btn btn-${variant} ${textColour}`" :type="type" :disabled="disabled || pending">
    <slot />
    <i v-if="pending" class="fa fa-spinner fa-spin" />
  </button>
</template>

<script lang="ts" setup>
import { PropType, computed, defineComponent } from 'vue'

const variantsWithWhiteText = ['']

const props = withDefaults(
  defineProps<{
    disabled?: boolean
    pending?: boolean
    type?: 'button' | 'submit' | 'reset' | undefined
    variant?: string
  }>(),
  {
    type: 'button',
    variant: 'primary',
  },
)

const textColour = computed(() => (variantsWithWhiteText.includes(props.variant) ? 'text-white' : ''))
</script>

<style lang="scss" scoped>
i {
  margin-left: 0.5em;
}
</style>
